import { h, Component } from 'preact';

import { sections } from 'pages/bolt_pages';

import Store from 'store/store';
import 'store/bolt/footer';
import { getCopy } from 'utils/copy';
import { smoothScrollTo } from 'utils/smoothScroll';
import { accessNested, joinClasses, sortObjectByOrder } from 'utils/utils';
import { getIsSinglePageIframed } from 'utils/bolt/client';
import Link from 'components/bolt/link/link';
import Button from 'components/bolt/button/button';
import Close from 'components/bolt/icons/close';
import ArrowDown from 'components/bolt/icons/arrowDown';
import { SonyFooter } from 'pages/bolt_features';
import HTML from 'components/core/html/html.js';
import * as webp from 'utils/bolt/webp';

import s from 'components/bolt/footer/footer.sss';

const dom = el => el?.base || el;

export default class Footer extends Component {
	constructor(props) {
		super(props);
		this.renderOpenFooter = this.renderOpenFooter.bind(this);
		this.toggleFooter = this.toggleFooter.bind(this);
		this.closeFooter = this.toggleFooter.bind(this, false);
		this.openFooter = this.toggleFooter.bind(this, true);
		this.getFallbackFormat = this.getFallbackFormat.bind(this);
		this.startAutoExpandTimer = this.startAutoExpandTimer.bind(this);
		this.stopAutoExpandTimer = this.stopAutoExpandTimer.bind(this);
		this.cancelAutoExpanding = this.cancelAutoExpanding.bind(this);
		this.footerData = accessNested(props, 'data.defaultFooter', {});
		this.sticky = accessNested(props, 'data.defaultFooter.position', 'fixed') === 'fixed';
		this.autoExpand = accessNested(props, 'data.defaultFooter.autoExpand', false);
		this.autoExpandDuration = accessNested(props, 'data.defaultFooter.autoExpandDuration', 3);
		let region = accessNested(props, 'store.appData.meta.region.slug');
		this.tealiumCookiesEnabled = region !== 'au' && accessNested(props, 'store.appData.options.enableTealium', false);
		this.ensightenTrackingEnabled = props.store?.appData?.options?.enableEnsighten;
		this.allowAutoExpand = accessNested(props, 'store.footer.allowAutoExpand', true);
		this.fontStyles = accessNested(props, 'store.appData.styling.fontVariables', {});
		this.showtimesFooter = props.parent === 'showtimes';
		this.pressKitFooter = props.parent === 'pressKit';
		this.hasTextPage = Object.values(accessNested(props, 'store.appData.pages', {})).find(e => e.component === 'text' || e.page === 'text');

		this.state = {
			open: false,
			autoExpanding: false,
			backgroundColor: null
		};
	}

	componentDidMount() {
		if (this.autoExpand && this.allowAutoExpand) {
			this.startAutoExpandTimer();
		}
		this.updateCoveredScreenSize();
	}

	componentDidUpdate() {
		if (!this.props.parent) {
			const activePage = this.props.store.activePage;
			let lowestSection = activePage;
			if (activePage === 'boltHome' && sections) {
				lowestSection = sections[sections.length - 1]?.id;
			}
			let elem = lowestSection && document.querySelector(`[data-section=${lowestSection}]`);
			let backgroundColor = elem && window.getComputedStyle(elem).backgroundColor;
			if (backgroundColor && this.state.backgroundColor !== backgroundColor) {
				this.setState({ backgroundColor });
			}
		} else if (!this.state.backgroundColor && this.props.fallBackColor) {
			this.setState({ backgroundColor: this.props.fallBackColor });
		}
		this.updateCoveredScreenSize();
	}

	updateCoveredScreenSize() {
		if (!this.$cta) {
			return;
		}
		let isMobile = this.props.store?.client?.deviceSize === 'mobile';
		let coveredScreenSize = isMobile && this.sticky ? dom(this.$cta).offsetHeight : 0;
		if (coveredScreenSize !== this.props.store.footer.coveredScreenSize) {
			Store.get().footer.set({ coveredScreenSize });
		}
	}

	startAutoExpandTimer() {
		this.setState({
			open: true,
			autoExpanding: true
		});

		const duration = this.autoExpandDuration * 1000;
		this.collapseTimer = window.setTimeout(() => {
			this.cancelAutoExpanding();
		}, duration);

	}

	stopAutoExpandTimer() {
		window.clearTimeout(this.collapseTimer);
	}

	cancelAutoExpanding() {
		this.setState({
			open: false,
			autoExpanding: false
		});
		this.stopAutoExpandTimer();
		Store.emit('FOOTER_AUTO_EXPANDED');
	}

	isLoneVideoDefaultFooter() {
		const defaultFooter = accessNested(this.props, 'data.defaultFooter');
		if (!defaultFooter) {
			return false;
		}
		const pages = Object.keys(accessNested(this.props, 'store.appData.pages', {}));
		const pageExceptions = ['boltVideos', 'bolt-toolkit', 'boltBanner', 'browser-not-supported', 'boltIframe'];
		const otherPages = pages.filter(id => !pageExceptions.includes(id));
		return (otherPages.length === 0);
	}


	toggleFooter(state) {
		const open = typeof state === 'boolean' ? state : !this.state.open;
		this.setState({ open });

		if (open && this.showtimesFooter) {
			const showtimesScroller = document.querySelector(`[data-section=scroller]`);
			const bottom = this.base.offsetTop + this.base.offsetHeight;
			smoothScrollTo(showtimesScroller, bottom, 300);
		}

	}

	renderOpenFooter() {
		const {
			logos,
			links,
			copyright
		} = this.footerData;

		const footerBgStyling = accessNested(Store.get(), 'appData.styling.variables.footerBgColor', this.state.backgroundColor);
		const accessibilityCopy = accessNested(Store.get(), 'appData.copy.accessibilityCopy', {});


		const autoExpanding = this.state.autoExpanding;

		const footerStyle = {
			background: !this.pressKitFooter && footerBgStyling
		};

		return (
			<div class={joinClasses(s.openWrapper, autoExpanding && s.autoExpanding)} style={footerStyle} role="contentinfo">
				<Button
					class={s.closeBtn}
					trigger={autoExpanding ? this.cancelAutoExpanding : this.toggleFooter}
					ariaLabel={accessibilityCopy.$COLLAPSE_FOOTER_ARIA}
				>
					<Close />
				</Button>
				<div class={joinClasses(s.studioDetails)}>
					{this.getLogos(logos)}
					<div class={s.line} />
					<ul class={s.links}>
						{this.renderLinks(links, 'link')}
					</ul>
				</div>
				<ul class={joinClasses(s.copyright, this.fontStyles.footerCopyright)}>
					{this.renderLinks(copyright, 'copyright')}
				</ul>
			</div>
		);
	}

	getLogos(logos) {
		if (!logos) {
			return;
		}
		return (
			<ul class={s.logos}>
				{this.renderLinks(logos, 'logo')}
			</ul>
		);
	}

	tealiumAction() {
		if (window.DisneyGDPR && window.DisneyGDPR.Core && typeof window.DisneyGDPR.Core.openPreferencesDialog === 'function') {
			window.DisneyGDPR.Core.openPreferencesDialog();
		}
	}

	ensightenAction(e) {
		if (typeof window.__dataLayer?.OneTrustDialog === 'function') {
			window.__dataLayer?.OneTrustDialog(e);
		}
	}

	getFallbackFormat() {
		return accessNested(this.props, 'appData.footer.alternativeImageFormat', 'png');
	}

	renderLinks(items, type) {
		const ageGateEnabled = accessNested(Store.get(), 'appData.options.ageGate', false);
		const isOfAge = accessNested(Store.get(), 'client.ofAge', null);
		items = sortObjectByOrder(items).filter(item => {
			const ageGateShowOnly = !item.ageGateShowOnly ? 0 : +(item.ageGateShowOnly);
			if (!ageGateEnabled && ageGateShowOnly !== 2) {
				return true;
			}
			return !ageGateShowOnly
				|| (ageGateShowOnly === 1 && isOfAge === true)
				|| (ageGateShowOnly === 2 && !isOfAge);
		});

		let links = [];

		const auRegions = ['au', 'nz'];
		const isAuRegion = auRegions.indexOf(Store.get().appData?.meta?.region?.slug.toLowerCase()) !== -1;

		if (type === 'link' && (this.tealiumCookiesEnabled || (this.ensightenTrackingEnabled && !isAuRegion))) {
			links.push(
				<li class={s[`${type}Wrapper`]} key="tealium">
					<Button
						class={joinClasses(s[`${type}Link`], this.fontStyles.footerLegalLinks)}
						trigger={this.ensightenTrackingEnabled ? this.ensightenAction : this.tealiumAction}
					>
						{accessNested(this.props, 'appData.copy.$COOKIE_CONSENT') || 'Cookie Settings'}
					</Button>
				</li>
			);
		}

		return links.concat(items.map((item, key) => {
			if (item.excludeFromShowtimes && this.showtimesFooter) {
				return;
			}
			if (item.showtimesOnly && !this.showtimesFooter) {
				return;
			}

			let content;
			if (type === 'logo') {
				const fileImg = item.src;
				const fallbackFormat = this.getFallbackFormat();

				content = (
					<webp.Picture
						class={s.logo}
						src={fileImg}
						alt={getCopy(item.alt, {}, '', null, 'accessibilityCopy') || item.alt}
						fallbackFormat={fallbackFormat}
					/>
				);

			} else {
				content = getCopy(item.$copy, {}, '', null, 'baseCopy') || item.$copy;
			}

			if (type === 'copyright') {
				content = (
					<HTML
						content={content}
						markdown
					/>
				);
			}

			if (item.url && item.url.startsWith('@')) {
				return (
					<li class={s[`${type}Wrapper`]} key={key}>
						<Button
							class={joinClasses(s[`${type}Link`], this.fontStyles[type === 'copyright' ? 'footerCopyright' : 'footerLegalLinks'])}
							trigger={() => Store.emit('OPEN_RESERVED_VARIABLE_LINK', item.url)}
						>
							{content}
						</Button>
					</li>
				);
			}

			if (item.url && accessNested(Store.get(), `appData.pages.${item.url}`, false)) {
				return (
					<li class={s[`${type}Wrapper`]} key={key}>
						<Button
							class={joinClasses(s[`${type}Link`], this.fontStyles[type === 'copyright' ? 'footerCopyright' : 'footerLegalLinks'])}
							trigger={() => Store.emit('CLOSE_AND_NAVIGATE', item.url, '', { instant: false })}
						>
							{content}
						</Button>
					</li>
				);
			}

			let Element = item.url ? Link : 'div';
			if (!item.url && item.openCookieConsentTool) {
				Element = 'button';
			}
			let attributes = {
				class: joinClasses(s[`${type}Link`], this.fontStyles[type === 'copyright' ? 'footerCopyright' : 'footerLegalLinks']),
				ariaLabel: item.ariaLabel,
				title: item.title,
				onClick: item.openCookieConsentTool ? () => window.evidon?.notice?.showPreferencesDialog() : null
			};
			if (item.url) {
				const disableNoOpNoRef = accessNested(this.props, 'data.defaultFooter.disableNoOpenerNoReferrer', false);
				attributes.href = item.url;
				attributes.target = item.target || '_blank';
				attributes.rel = !disableNoOpNoRef && 'noopener noreferrer';
			}

			return (
				<li class={s[`${type}Wrapper`]} key={key}>
					<Element {...attributes}>{content}</Element>
				</li>
			);
		}));
	}

	renderExtra() {}

	render(props, state) {
		const {
			data,
			scrollElem,
			store,
			isHomeEntFooter
		} = props;

		const accessibilityCopy = accessNested(store, 'appData.copy.accessibilityCopy', {});
		// const isDesktop = accessNested(store, 'client.isDesktopSize');

		const copyright = accessNested(data, 'defaultFooter.copyright');

		const videosFooter = accessNested(store, 'header.videoOverlayOpen', false);
		const loneVideoDefaultFooter = videosFooter && this.isLoneVideoDefaultFooter();
		const stickyState = this.sticky || videosFooter;
		const staticAutoExpand = !this.sticky && accessNested(data, 'defaultFooter.autoExpand', false);
		const inlineFooter = accessNested(data, 'defaultFooter.position') === 'static' && accessNested(data, 'defaultFooter.inline', false);

		const { ctaOpenCopy = 'FOOTER_CTA', ctaCloseCopy = 'FOOTER_CLOSE' } = data.defaultFooter || {};
		const toggleButtonText = state.open ? getCopy(ctaCloseCopy, {}, '', null, 'baseCopy') : getCopy(ctaOpenCopy, {}, '', null, 'baseCopy');
		const toggleButtonAria = state.open ? accessibilityCopy.$COLLAPSE_FOOTER_ARIA : accessibilityCopy.$EXPAND_FOOTER_ARIA;

		const isSinglePageIframed = getIsSinglePageIframed();

		// let follow

		const style = {};
		if (!this.showtimesFooter && !this.hasTextPage && !this.pressKitFooter) {
			style.backgroundColor = state.backgroundColor;
		}

		const activePage = store.activePage;
		const dedicatedIframePage = accessNested(store, ['appData', 'pages', activePage, 'page']) === 'iframe';

		const synopsisFooterShadow = store?.synopsis?.addShadowToFooter;
		const tiledItemsFooterShadow = store?.tiledItems?.addShadowToFooter;
		const needsShadow = (synopsisFooterShadow || tiledItemsFooterShadow || activePage === 'boltWatchMore') && !this.showtimesFooter;
		const sonyFooter = accessNested(data, 'sonyFooter', false);
		const copy = accessNested(props, 'store.appData.copy', {});

		if (sonyFooter) {
			return (
				<footer
					data-section="boltFooter"
					style={style}
					class={joinClasses({
						s, wrapper: true,
						sticky: stickyState,
						open: state.open,
						showtimes: this.showtimesFooter,
						homeEnt: isHomeEntFooter,
						sidePanelOpen: accessNested(store, 'showtimes.show', false) || accessNested(store, 'homeEnt.show', false)
					})}
					role="contentinfo"
				>
					{needsShadow && <div class={s.shadow} />}
					<SonyFooter data={data.sonyFooter} showtimes={this.showtimesFooter} copy={copy} />
				</footer>
			);
		}

		if (activePage === 'boltHome') {
			const noSynopsisOrGallerySections = !sections.find(section => ['boltSynopsis', 'boltGallery'].includes(section.id));
			if (noSynopsisOrGallerySections) {
				style.backgroundColor = '';
			}
		}

		return (
			<footer
				data-section="boltFooter"
				style={style}
				class={joinClasses({
					s, wrapper: true,
					sticky: stickyState,
					open: state.open,
					showtimes: this.showtimesFooter,
					pressKit: this.pressKitFooter,
					homeEnt: isHomeEntFooter,
					sidePanelOpen: accessNested(store, 'showtimes.show', false) || accessNested(store, 'homeEnt.show', false),
					loneVideoDefaultFooter: loneVideoDefaultFooter,
					staticAutoExpand,
					inlineFooter,
					dedicatedIframePage
				})}
				role="contentinfo"
			>
				{needsShadow && <div class={s.shadow} />}
				<div class={joinClasses(s.outer, isSinglePageIframed && s.noLegalBtn)}>
					<Button
						class={s.scrollTop}
						trigger={() => smoothScrollTo(scrollElem || document.getElementById('mainScroll'), 0, 300)}
						ariaLabel={accessibilityCopy.$SCROLL_UP_ARIA}
					>
						<ArrowDown class={s.arrow} />
					</Button>
					{copyright && <ul class={s.copyright} key="copyright">{this.renderLinks(copyright, 'copyright')}</ul>}
					<div class={s.sizer} />
					<Button
						class={joinClasses(s.cta, this.fontStyles.footerLegalButton, isSinglePageIframed && s.hidden)}
						trigger={this.toggleFooter}
						key="toggle"
						ariaLabel={toggleButtonAria}
						ref={e => this.$cta = e}
					>
						{toggleButtonText}
					</Button>
				</div>
				<div class={s.openCropper}>
					{this.renderOpenFooter()}
					{inlineFooter && (
						<Button
							class={s.scrollTop}
							trigger={() => smoothScrollTo(scrollElem || document.getElementById('mainScroll'), 0, 300)}
							ariaLabel={accessibilityCopy.$SCROLL_UP_ARIA}
						>
							<ArrowDown class={joinClasses(s.arrow, s.arrowTop)} />
						</Button>
					)}
				</div>
				{this.renderExtra()}
			</footer>
		);
	}
}
